import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-upi-id',
  templateUrl: './upi-id.component.html',
  styles: [
  ]
})
export class UpiIDComponent implements OnInit {

  upiReg = new RegExp('[a-zA-Z0-9\.\-]{2,256}\@[a-zA-Z][a-zA-Z]{2,64}');
  vpaID = new UntypedFormControl('', Validators.pattern(this.upiReg));

  constructor(
    private dialogRef: MatDialogRef<UpiIDComponent>
  ) { }

  ngOnInit(): void {
  }

  close(){
    this.dialogRef.close()
  }

  confirm(){
    if(this.vpaID.valid){
      this.dialogRef.close(this.vpaID.value)
    } else{
      this.close()
    }
  }

}
